/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ConditionDto,
  GetResourceObjectsByResourceIdParams,
  ResourceObjectDto,
  ResourceObjectDtoPagination,
  ResourceObjectPageRequest
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetPaginatedResourceObjectsUrl = () => {


  

  return `/api/ResourceObject/GetPaginatedResourceObjects`
}

export const getPaginatedResourceObjects = async (resourceObjectPageRequest: ResourceObjectPageRequest, options?: RequestInit): Promise<ResourceObjectDtoPagination> => {
  
  return customInstance<ResourceObjectDtoPagination>(getGetPaginatedResourceObjectsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      resourceObjectPageRequest,)
  }
);}




export const getGetPaginatedResourceObjectsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPaginatedResourceObjects>>, TError,{data: BodyType<ResourceObjectPageRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getPaginatedResourceObjects>>, TError,{data: BodyType<ResourceObjectPageRequest>}, TContext> => {

const mutationKey = ['getPaginatedResourceObjects'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPaginatedResourceObjects>>, {data: BodyType<ResourceObjectPageRequest>}> = (props) => {
          const {data} = props ?? {};

          return  getPaginatedResourceObjects(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetPaginatedResourceObjectsMutationResult = NonNullable<Awaited<ReturnType<typeof getPaginatedResourceObjects>>>
    export type GetPaginatedResourceObjectsMutationBody = BodyType<ResourceObjectPageRequest>
    export type GetPaginatedResourceObjectsMutationError = ErrorType<unknown>

    export const useGetPaginatedResourceObjects = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPaginatedResourceObjects>>, TError,{data: BodyType<ResourceObjectPageRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getPaginatedResourceObjects>>,
        TError,
        {data: BodyType<ResourceObjectPageRequest>},
        TContext
      > => {

      const mutationOptions = getGetPaginatedResourceObjectsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getGetConditionsUrl = () => {


  

  return `/api/ResourceObject/GetConditions`
}

export const getConditions = async ( options?: RequestInit): Promise<ConditionDto[]> => {
  
  return customInstance<ConditionDto[]>(getGetConditionsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetConditionsQueryKey = () => {
    return [
    `/api/ResourceObject/GetConditions`
    ] as const;
    }

    
export const getGetConditionsQueryOptions = <TData = Awaited<ReturnType<typeof getConditions>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConditionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConditions>>> = ({ signal }) => getConditions({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetConditionsQueryResult = NonNullable<Awaited<ReturnType<typeof getConditions>>>
export type GetConditionsQueryError = ErrorType<unknown>


export function useGetConditions<TData = Awaited<ReturnType<typeof getConditions>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConditions>>,
          TError,
          Awaited<ReturnType<typeof getConditions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConditions<TData = Awaited<ReturnType<typeof getConditions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConditions>>,
          TError,
          Awaited<ReturnType<typeof getConditions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConditions<TData = Awaited<ReturnType<typeof getConditions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetConditions<TData = Awaited<ReturnType<typeof getConditions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetConditionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetConditionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getConditions>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConditionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConditions>>> = ({ signal }) => getConditions({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetConditionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getConditions>>>
export type GetConditionsSuspenseQueryError = ErrorType<unknown>


export function useGetConditionsSuspense<TData = Awaited<ReturnType<typeof getConditions>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConditionsSuspense<TData = Awaited<ReturnType<typeof getConditions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConditionsSuspense<TData = Awaited<ReturnType<typeof getConditions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetConditionsSuspense<TData = Awaited<ReturnType<typeof getConditions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetConditionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetResourceObjectsByResourceIdUrl = (params?: GetResourceObjectsByResourceIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ResourceObject/GetResourceObjectsByResourceId?${stringifiedParams}` : `/api/ResourceObject/GetResourceObjectsByResourceId`
}

export const getResourceObjectsByResourceId = async (params?: GetResourceObjectsByResourceIdParams, options?: RequestInit): Promise<ResourceObjectDto[]> => {
  
  return customInstance<ResourceObjectDto[]>(getGetResourceObjectsByResourceIdUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetResourceObjectsByResourceIdQueryKey = (params?: GetResourceObjectsByResourceIdParams,) => {
    return [
    `/api/ResourceObject/GetResourceObjectsByResourceId`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetResourceObjectsByResourceIdQueryOptions = <TData = Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError = ErrorType<unknown>>(params?: GetResourceObjectsByResourceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceObjectsByResourceIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>> = ({ signal }) => getResourceObjectsByResourceId(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetResourceObjectsByResourceIdQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>>
export type GetResourceObjectsByResourceIdQueryError = ErrorType<unknown>


export function useGetResourceObjectsByResourceId<TData = Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError = ErrorType<unknown>>(
 params: undefined |  GetResourceObjectsByResourceIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceObjectsByResourceId>>,
          TError,
          Awaited<ReturnType<typeof getResourceObjectsByResourceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetResourceObjectsByResourceId<TData = Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectsByResourceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceObjectsByResourceId>>,
          TError,
          Awaited<ReturnType<typeof getResourceObjectsByResourceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetResourceObjectsByResourceId<TData = Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectsByResourceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetResourceObjectsByResourceId<TData = Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectsByResourceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetResourceObjectsByResourceIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetResourceObjectsByResourceIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError = ErrorType<unknown>>(params?: GetResourceObjectsByResourceIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceObjectsByResourceIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>> = ({ signal }) => getResourceObjectsByResourceId(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetResourceObjectsByResourceIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>>
export type GetResourceObjectsByResourceIdSuspenseQueryError = ErrorType<unknown>


export function useGetResourceObjectsByResourceIdSuspense<TData = Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError = ErrorType<unknown>>(
 params: undefined |  GetResourceObjectsByResourceIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetResourceObjectsByResourceIdSuspense<TData = Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectsByResourceIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetResourceObjectsByResourceIdSuspense<TData = Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectsByResourceIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetResourceObjectsByResourceIdSuspense<TData = Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectsByResourceIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetResourceObjectsByResourceIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




